module.exports = __webpack_public_path__ + "img/photosession_1_5.9a4f585d.jpg";